import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'
import { getFirstItem } from 'lib/util'

/**
 * Display the serial number for a sensor.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmMachine = (classes, props = {}) => {
  const { project = '-', item } = props
  const device = getFirstItem(item)
  const { name = '-' } = device?.value || {}
  const nameAndProject = `${name} ${project}`

  return (
    <Text
      color={'black'}
      variant={'14/bold'}
      className={classes.row}
    >
      {nameAndProject}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmMachine)
